import styled from 'styled-components';

export const Subregion = styled.div`
  margin-bottom: 40px;
`;

export const SubregionTitle = styled.h2`
  font-size: 14px;
  font-weight: 400;
  color: #000;
  margin-bottom: 0;

  @media (min-width: 577px) {
    font-size: 18px;
    margin-bottom: 0.5rem;
  }
`;

export const SubregionBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;

  @media (min-width: 577px) {
    font-size: 18px;
    margin-bottom: 0.5rem;
    flex-direction: row;
  }
`;

export const AngleDownIcon = styled.span`
  transform: rotate(90deg);
  display: inline-block;
  font-size: 0.875rem;
  margin-left: 3px;
  position: relative;
  top: 1px;
`;
